import { Grid2 } from '@mui/material';
import { EventListProps } from 'components/event/EventList';
import { EventGridItem } from 'components/event/layout/EventGridItem';

export function EventGrid(props: EventListProps) {
  return (
    <Grid2 container spacing={2} sx={{ my: 3 }}>
      {props.eventList.map((event, index) => {
        return (
          <EventGridItem
            key={index}
            event={event}
            onDeleteEvent={() => props.onDeleteEvent?.(event)}
            onRestoreEvent={() => props.onRestoreEvent?.(event)}
          />
        );
      })}
    </Grid2>
  );
}
